import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Group from '../Group/Group';
import Tabs from '../Tabs/Tabs';

export default class TabsExample extends Component {

  state = {};

  onChangeTab = (e, index, name) => {
    window.showAppInfo(`${name} tab`);
    this.setState({ selected: index });
  };

  onChange = e => this.setState(e.target.value);

  render() {
    const extraTabs = [
      <div key="4" name="Tab 4">
        Tab 4 is placed inside an array.
      </div>,
      <div key="5" name="Tab 5" disabled>
        Tab 5 is placed inside an array, and is disabled, so cannot be clicked.
      </div>,
      undefined, // will be filtered out
      null, // will be filtered out
    ];

    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Tabs.defaultProps} propTypes={Tabs.propTypes} propValues={this.state}/>
        <Tabs {...this.state} onChange={this.onChangeTab}>
          <Group name="Tab 1">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
          </Group>
          <Group name="Tab 2">
            <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
            <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
          </Group>
          <Group name="Tab 3">
            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
            <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
          </Group>
          {extraTabs}
        </Tabs>
        <SourceCode querySelector=".tabs-example .core-tabs"/>
      </Example>
    );
  }

}
